export const reduxUtil = {
    getUserEmail: ({ auth }) => auth.user.email,
    getReduxAccToken: state => state.auth.accessToken,
    getCurrentAuthInfo: state => state.auth,
    getCurrentUserInfo: state => state.auth.user,
    getNotificationsFilter: ({ pushNotifications }) => pushNotifications.notifications_filter,
    getPromotionsFilter: ({ promotions }) => promotions.promotion_filters,
    getPromotionsList: ({ promotions }) => promotions.promotions_list,
    getCurrentPromo: ({ promotions }) => ({ ...promotions.promo_details }),
    getEditing: ({ promotions }) => promotions.is_editing_completed_promo,
    getPrioritizationFailedStatus: ({ promotions }) => promotions.update_promotion_failed,
    getPrioritizePromos: ({ promotions }) => promotions.prioritize_promos,
    getCurrNotif: ({ pushNotifications }) => pushNotifications.notification_details,
    getNotificationsList: ({ pushNotifications }) => pushNotifications.notifications_list,
    isSideMenuOpened: ({ common }) => common.is_side_menu_opened,
    getReduxStoreFilters: ({ stores }) => stores.store_filters,
    getProductsPageNo: ({ products }) => products.get('pageNo'),
    getProductsSize: ({ products }) => products.get('size'),
    getProductDraftID: ({ products }) => products.get('_id'),
    getProduct: ({ products }) => products.get('product_details'),
    getProdStatus: ({ products }) => products.get('isProductProdPublished'),
    getManageUpdatesProducts: ({ products }) => products.get('manage_updates').products,
    getManageProductsFilters: ({ products }) => products.get('manage_updates_filter'),
    getProductsFilters: ({ products }) => products.get('products_filter'),
    isModifiedAreaAutoUpdated: ({ products }) => products.get('isModifiedAreaAutoUpdated'),
}
